import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/clubcard-loyalty.png'
import _imports_1 from '@/assets/img/reward-coupon-icon.svg'
import _imports_2 from '@/assets/img/reward-coin-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-a96f17a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "clubcard-section"
}
const _hoisted_2 = { class: "clubcard-group" }
const _hoisted_3 = {
  key: 0,
  class: "clubcard-title"
}
const _hoisted_4 = { class: "clubcard-content-container" }
const _hoisted_5 = { class: "clubcard-content" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"clubcard-content-image-container\" data-v-a96f17a4><img class=\"clubcard-content-image\" src=\"" + _imports_0 + "\" data-v-a96f17a4></div><div class=\"clubcard-content-text-container\" data-v-a96f17a4><span class=\"clubcard-content-text-title\" data-v-a96f17a4>เริ่มต้นใช้งาน มายโลตัส</span><span class=\"clubcard-content-text-subtitle\" data-v-a96f17a4>สะสมคอยน์ แลกรีวอร์ด</span></div>", 2)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "clubcard-content-brn" }, "สมัครเลย", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "clubcard-content-rewards" }
const _hoisted_11 = {
  key: 0,
  class: "clubcard-content-rewards-container"
}
const _hoisted_12 = { class: "clubcard-content-rewards-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubcard-content-rewards-text" }, "รีวอร์ดที่คุณจะได้รับ", -1))
const _hoisted_14 = { class: "clubcard-content-rewards-all" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("ดูทั้งหมด ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubcard-content-rewards-coupon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, "รับคูปองกว่า 600 บาท ตลอดทุกเดือน")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubcard-content-rewards-coin" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", null, "สะสมคอยน์ แลกส่วนลดทุกการช้อป")
], -1))
const _hoisted_18 = {
  key: 1,
  class: "clubcard-section"
}
const _hoisted_19 = { class: "clubcard-group" }
const _hoisted_20 = { class: "clubcard-content-container skeleton" }
const _hoisted_21 = { class: "clubcard-content" }
const _hoisted_22 = { class: "clubcard-content-image-container" }
const _hoisted_23 = { class: "clubcard-content-text-container" }
const _hoisted_24 = { class: "clubcard-content-rewards" }
const _hoisted_25 = { class: "clubcard-content-rewards-btn open" }
const _hoisted_26 = { class: "clubcard-content-rewards-container" }
const _hoisted_27 = { class: "clubcard-content-rewards-title" }
const _hoisted_28 = { class: "clubcard-content-rewards-text" }
const _hoisted_29 = { class: "clubcard-content-rewards-all" }
const _hoisted_30 = { class: "clubcard-content-rewards-coupon" }
const _hoisted_31 = { class: "clubcard-content-rewards-coin" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoadingPoints)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isFirstAccess())
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "ขอบคุณสำหรับการเชื่อมต่อบัญชีของคุณ"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", {
                  class: "clubcard-content-btn-container",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.updateCustomer()))
                }, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(["clubcard-content-rewards-btn", { 'open': _ctx.openRewards }])
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = () => _ctx.openRewards = !_ctx.openRewards)
                  }, [
                    (_ctx.openRewards)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "fa-solid fa-chevron-up"
                        }))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          icon: "fa-solid fa-chevron-down"
                        }))
                  ])
                ], 2),
                (_ctx.openRewards)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("button", null, [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                          ])
                        ])
                      ]),
                      _hoisted_16,
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoadingPoints)
      ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_q_skeleton, {
                    class: "skeleton-img",
                    width: "54px",
                    height: "34px"
                  })
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_q_skeleton, {
                    class: "skeleton-title",
                    width: "172px",
                    height: "16px"
                  }),
                  _createVNode(_component_q_skeleton, {
                    class: "skeleton-subtitle",
                    width: "158px",
                    height: "12px"
                  })
                ]),
                _createVNode(_component_q_skeleton, {
                  class: "skeleton-btn",
                  width: "72px",
                  height: "28px"
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", null, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-up" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-title",
                        width: "172px",
                        height: "20px"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-title",
                        width: "69px",
                        height: "16px"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-icon",
                      width: "61.5px",
                      height: "48px"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-title",
                      width: "100%",
                      height: "20px"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-icon",
                      width: "61.5px",
                      height: "48px"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-title",
                      width: "100%",
                      height: "20px"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}